export default __webpack_public_path__ + "static/media/find.0148a68d.svg";